// eslint-disable-next-line import/prefer-default-export
export var SET_FEATURES = 'SET_FEATURES';